<template>
  <Loader :flag="isLoading">
    <div v-if="!items?.length" class="mt-3">
      <p class="fs-6">{{ emptyMessage }}</p>
    </div>
    <draggable
      v-else-if="draggable"
      :modelValue="items"
      @update:modelValue="$emit('update:items', $event)"
      item-key="id"
      :disabled="dragDisabled"
      @end="$emit('drag-end')"
      class="list-group list-group-checkable d-grid gap-2 border-0"
      ghost-class="ghost"
      handle=".drag-handle"
      :scroll="scrollContainer"
      :scrollSensitivity="50"
      :scrollSpeed="scrollSpeed"
      :forceFallback="true"
      :bubbleScroll="true">
      <template #item="{element: item}">
        <li
          :class="[itemClass, editId === item.id ? editClass : '']"
          class="list-group-item rounded-3 py-3">
          <slot
            name="item-display"
            :item="item"
            :is-editing="editId === item.id"
            :start-edit="() => $emit('start-edit', item)">
          </slot>
          <slot
            name="item-edit"
            :item="item"
            :is-editing="editId === item.id">
          </slot>
        </li>
      </template>
    </draggable>
    <ul
      v-else
      class="list-group list-group-checkable d-grid gap-2 border-0">
      <li
        v-for="item in items"
        :key="item.id"
        :class="[itemClass, editId === item.id ? editClass : '']"
        class="list-group-item rounded-3 py-3">
        <slot
          name="item-display"
          :item="item"
          :is-editing="editId === item.id"
          :start-edit="() => $emit('start-edit', item)">
        </slot>
        <slot
          name="item-edit"
          :item="item"
          :is-editing="editId === item.id">
        </slot>
      </li>
    </ul>
  </Loader>
</template>

<script>
import { Loader } from '@/components/parts';
import draggable from 'vuedraggable';

export default {
  name: 'AdminItemList',
  components: {
    Loader,
    draggable,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    emptyMessage: {
      type: String,
      default: '※データが登録されていません。新規登録してください。',
    },
    draggable: {
      type: Boolean,
      default: false,
    },
    dragDisabled: {
      type: Boolean,
      default: false,
    },
    editId: {
      type: [Number, String],
      default: null,
    },
    itemClass: {
      type: String,
      default: '',
    },
    editClass: {
      type: String,
      default: 'edit',
    },
    scrollContainer: {
      type: [HTMLElement, null],
      default: null,
    },
    scrollSpeed: {
      type: Number,
      default: 30,
    },
  },
  emits: ['update:items', 'drag-end', 'start-edit'],
};
</script>

<style lang="scss" scoped>
.list-group-item {
  border: 2px solid rgba(152, 121, 89, 1);
  border-top-width: 1px !important;
}

.ghost {
  opacity: 0.5;
  background: #f0f0f0;
}
</style>
